"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertISO3ToBCP47 = convertISO3ToBCP47;
function convertISO3ToBCP47(iso3) {
    const mapper = {
        eng: "en-US",
        por: "pt-BR",
    };
    return mapper[iso3];
}
//# sourceMappingURL=language.utils.js.map